//
//
//
//

export default {
  props: {
    barData: {
      type: Array, default: () => []
    }
  },
  data () {
    return {
      xData: [],
      data: [],
      barChart: null // 图表实例
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.barChart?.resize()
    },
    barData: {
      handler (newVal) {
        this.getData()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  beforeDestroy () {
    this.barChart?.clear() // 清空当前实例
    this.barChart?.dispose() // 销毁图表
    this.barChart = null
  },
  methods: {
    getData () {
      this.xData = []
      this.data = []
      this.barData?.forEach((item) => {
        this.xData.push(item.date)
        this.data.push({
          name: item.date,
          value: item.burstMoney
        })
      })
      this.getBarCharts()
    },
    getBarCharts () {
      if (!this.barChart) this.barChart = this.$echarts.init(document.getElementsByClassName('burstdetails-bar-charts')[0])
      const option = {
        grid: {
          left: '3%',
          right: '3%',
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          confine: true,
          backgroundColor: 'rgba(0,0,0,.7)',
          formatter: (params) => {
            return `<div class="tooltip-box">
            <div class="item"><span>${this.$t('TYY_000629')}: </span>${params.name}</div>
            <div class="item"><span>${this.$t('TYY_000123')}: </span>${this.num2CurrencyNo(params.value)}</div>
            </div>`
          }
        },
        xAxis: [
          {
            type: 'category',
            data: this.xData,
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#A3A3A3',
              // rotate: 40
              margin: 30
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#A3A3A3'
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: ['rgba(0, 0, 0, 0.05)']
              }
            }
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            // barWidth: 26,
            barMaxWidth: 26,
            barMinHeight: 10,
            itemStyle: {
              normal: {
                color: '#5C8AE5'
              },
              emphasis: {
                color: '#96B9FF'
              }
            },
            data: this.data
          }
        ]
      }
      this.barChart?.clear()
      this.barChart?.setOption(option, true)
    }
  }
}
